import { ModuleDropdown } from '@ghq-abi/design-system';
import { useTranslate } from '@tolgee/react';

import { useModuleItems } from './hooks/useModuleItems';

export function ModulesDropdown() {
  const { t } = useTranslate('web-app');
  const { items } = useModuleItems();

  return (
    <ModuleDropdown
      title={t('modules.quick_access', 'Quick Access')}
      items={items}
    />
  );
}
